import { render, staticRenderFns } from "./WillDistributionDetails.vue?vue&type=template&id=53d13fe2"
import script from "./WillDistributionDetails.vue?vue&type=script&lang=js"
export * from "./WillDistributionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports